const styles = {
  wrapper: {
    backgroundColor: '#fff',
    color: '#444',
  },

  header: {
    gridArea: 'header',
    padding: '5px 15px',
    fontSize: 24,
    fontFamily: 'League Gothic',
  },
  nav: {
    position: 'relative',
    '& a': {
      '&:hover': {
        color: '#7F1431',
      },
    },
  },
  liveResults: {
    backgroundColor: 'red',
    color: 'white',
    padding: '1px 4px',
    fontFamily: 'League Gothic',
    fontSize: '12px',
    position: 'absolute',
    top: '-10px',
    right: '-25px',
    textTransform: 'uppercase',
  },
  kpis: {
    padding: '20px 10px',
    fontSize: 12,
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    backgroundColor: '#F4F5F0',
  },

  kpi: {
    flexGrow: 1,
    padding: '1.5em 1em',
    margin: '.5em',
    backgroundColor: '#FFFFFF',
    border: '1px solid #7F1431',
    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    width: '19%',
    boxShadow: '#7F1431 8px 8px 0px -3px',
    textAlign: 'center',
    // background-image: url(assets/images/france.png);
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: '0',
  },
  kpititle: {
    textAlign: 'center',
    fontSize: '2em',
    textTransform: 'uppercase',
    color: '#7F1431',
    fontFamily: 'League Gothic',
  },
  kpikpi: {
    fontSize: '3.5em',
    // color: '#63AC1F',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // height: '100%',
    // maxHeight: 55,
  },
  kpinum: {
    fontSize: 62,
    // color: '#63AC1F',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // gap: '10px',
    // height: '100%',
    // maxHeight: 55,
    // paddingTop: '0.5em',
  },
  kpisuffix: {
    fontSize: 12,
    maxWidth: 220,
    textAlign: 'center',
    // marginLeft: 10,
  },
  footer: {
    padding: 50,
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  contentcharts: {
    padding: 15,
    fontFamily: 'Roboto',
    // flexGrow: '2',
    // flexBasis: '600px',
    width: 'calc(100% - 250px)',
  },
  tablesrow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '30px',
    // justifyContent: 'space-between',
    // marginBottom: 10,
    // fontFamily: 'League Gothic',

  },
  table: {
    // padding: '0 10px',
    // flexGrow: 1,
    marginBottom: 20,
    // padding: '0 20px',
  },
  sectionTitle: {
    textTransform: 'uppercase',
    fontFamily: 'League Gothic',
    marginBottom: 5,
    marginTop: 10,
    fontSize: 26,
    color: '#7F1431',
  },
  charttitle: {
    textTransform: 'uppercase',
    fontFamily: 'League Gothic',
    marginBottom: 5,
    marginTop: 10,
    fontSize: 20,
    color: '#787878',
  },
  chartdescription: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: 800,
  },
  contentcolumns: {
    display: 'flex',
    flexDirection: 'row',
  },
  head: {
    fontSize: 18,
    paddingBottom: 10,
    // color: '#63AC1F',
    fontFamily: 'League Gothic !important',
  },
  sidebar: {
    // gridArea: 'sidebar',
    padding: 15,
    width: '250px',
    // flexBasis: 0,
    // backgroundColor: '#F4F5F0',
    borderRight: '2px solid #F4F5F0',

  },
  selectionsTitles: {
    fontSize: '1em',
    fontWeight: 'bold',
    fontFamily: 'League Gothic',
    textTransform: 'uppercase',
  },
  contentcol: {
    display: 'grid',
    gridTemplateRows: '0fr 1fr 0fr 1fr',
    gridRowGap: '10px',
  },
  chart200: {
    height: 200,
    marginBottom: 40,
  },
  chart: {
    height: 250,
    marginBottom: 40,
  },
  chart300: {
    height: 300,
    marginBottom: 40,
  },
  chart350: {
    height: 350,
    marginBottom: 40,
  },
  chart400: {
    height: 400,
    marginBottom: 40,
  },
  chart550: {
    height: 550,
    marginBottom: 40,
  },
  twoColCharts: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 40,
    '> *': {
      flex: '1 100%',
    },
  },
  // twoCharts: {
  //   height: '300',
  //   // width: '100%',
  // },
  thead: {
    color: '#63AC1F',
    borderBotom: '1px solid',
  },
  th: {
    fontWeight: '500',
  },
  tbody: {
    borderTop: '1px solid lightsteelblue',
  },
  teamname: {
    minWidth: 78,
  },
  legendTeamsRanking: {
    padding: '0 30px',
  },
  legend: {
    display: 'flex',
    flexDirection: 'row',
    padding: '6px 0',
    borderBottom: '1px solid #dedede',
    gap: '10px,',
  },
  legendRank: {
    fontFamily: 'League Gothic',
    fontSize: '18px',
    width: '80px',
  },
  legendTeams: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    gap: '10px',
    flexWrap: 'wrap',
    fontSize: '14px',
  },
  '@media (max-width: 1000px)': {
    contentcharts: {
      width: '100%',
    },
  },
  '@media (max-width: 769px)': {
    kpi: {
      width: '33%',
    },
  },
  '@media (max-width: 601px)': {
    kpis: {
      flexDirection: 'column',
      alignItems: 'center',
    },
    kpi: {
      width: '90%',
    },
    twoColCharts: {
      flexDirection: 'column',
    },
    legend: {
      display: 'block',
    },
    legendRank: {
      marginBottom: '5px',
    },
    legendTeams: {
      fontSize: '11px',
      columnGap: '10px',
      rowGap: '10px',
    },
  },

};

export default styles;
